<template>
  <div v-if="slider.length > 0" class="slider-area">
    <div class="slider-track">

      <div
        v-for="(item, index) in slider"
        :key="item.itiId"
        class="single-slider"
        :class="{ active: index === currentIndex }"
      >
        <!-- IMAGEM REAL -->
        <img
          class="slide-image"
          :src="getImage(item)"
          alt="slider"
        />

        <!-- overlay opcional -->
        <div class="slider-overlay">
          <div class="container">
            <div class="hero-caption" v-show="false">
              <h1>{{ item.itiNome }}</h1>
              <p v-html="item.itiResumo1"></p>
            </div>
          </div>
        </div>
      </div>

      <!-- DOTS -->
      <div v-if="slider.length > 1" class="navigation-avance">
        <span
          v-for="(item, index) in slider"
          :key="'dot-' + item.itiId"
          class="dot"
          :class="{ active: index === currentIndex }"
          @click="goToSlide(index)"
        />
      </div>

    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "PageSlider",

  data() {
    return {
      slider: [],
      currentIndex: 0,
      interval: null,
    };
  },

  mounted() {
    axios
      .get('/Process/InsInstitucional/institucional/34/slider/0/x')
      .then(response => {
        this.slider = response.data.sort((a, b) => {
          return (parseInt(a.itiOrdem) || 0) - (parseInt(b.itiOrdem) || 0);
        });

        if (this.slider.length > 1) {
          this.startSlider();
        }
      });
  },

  beforeUnmount() {
    clearInterval(this.interval);
  },

  methods: {
    getImage(item) {
      return item?.insInstitucionalImagens?.[0]?.itgUrlImagem
        ? this.$imgURL + item.insInstitucionalImagens[0].itgUrlImagem
        : '';
    },

    startSlider() {
      this.interval = setInterval(this.nextSlide, 5000);
    },

    nextSlide() {
      this.currentIndex =
        (this.currentIndex + 1) % this.slider.length;
    },

    goToSlide(index) {
      this.currentIndex = index;
      this.startSlider();
    },
  },
};
</script>

<style scoped>
.slider-area {
  width: 100%;
  overflow: hidden;
}

.slider-track {
  position: relative;
  width: 100%;
  height: clamp(200px, 36.5vw, 600px);
  background: #000; /* fundo para laterais */
}

.single-slider {
  position: absolute;
  inset: 0;
  opacity: 0;
  transition: opacity 0.8s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.single-slider.active {
  opacity: 1;
  z-index: 1;
}

/* 👇 ESSA É A CHAVE */
.slide-image {
  width: 100%;
  height: 100%;
  object-fit: contain; /* NÃO CORTA */
  object-position: center;
}

/* overlay opcional */
.slider-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
}

/* dots */
.navigation-avance {
  position: absolute;
  bottom: 15px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 8px;
}

.dot {
  width: 16px;
  height: 8px;
  border-radius: 10px;
  background: #947a06;
  cursor: pointer;
}

.dot.active {
  width: 26px;
  background: #fff;
}

/* MOBILE */
@media (max-width: 768px) {

.slider-area {
  width: 100%;
  padding-top: 85px;
  overflow: hidden;
}

  .slider-track {
    height: 160px;
  }

  .slide-image {
    object-fit: contain; /* aqui pode cortar levemente */
  }
}
</style>